import cashbackUA from './views/cashbackUA.c.js';
export default cashbackUA;
